/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Internal_Server_ErrorInputs */



/**
* | output |
* | --- |
* | "EISOX internal server error" |
*
* @param {Error_Internal_Server_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_internal_server_error = /** @type {((inputs?: Error_Internal_Server_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Internal_Server_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("EISOX internal server error")
	return /** @type {LocalizedString} */ ("Erreur interne du serveur EISOX")
});